import './App.css';
import Card from './components/card/Card';
import "../node_modules/bootstrap/dist/css/bootstrap.css"
import Project from './components/projects/Project';
import IndividualIntervalsExample from './components/slide/Slide';
import Footer from './components/footer/Footer';
import Navbar from './components/navbar/Navbar';

function App() {
  return (
    
    <div className="App" >
      <Navbar/>
     <div className='cr'><Card />
     <Project/>
     <br/>
    <h1 style={{color:'#007bff',fontStyle:"oblique",fontSize:"80px"}} >MY skills</h1></div>
    <div className='rs'  id='skills' > <IndividualIntervalsExample /></div>
    <Footer  />
    </div>

  );
}

export default App;
